<template>
    <v-container fluid class="container-main" style="position: relative;">
        <v-row id="GetInTouch" justify="center">
            <v-col cols="12" md="10">
                <v-row justify="space-between" class="mb-6">
                    <v-col cols="12" md="6" align-self="center">
                        <h3 class="text-title">
                            Get in Touch
                        </h3>
                    </v-col>
                    <v-col cols="12" md="5" align-self="center">
                        <p class="text-subtitle">
                            We’re here to help you achieve your marketing goals. Whether you’re ready to start a new
                            campaign or have questions about our services, reach out to us today.
                        </p>
                    </v-col>
                </v-row>
                <v-row justify="space-between">
                    <v-col cols="12">
                        <v-card class="card-main px-6 py-6 px-sm-12 py-sm-10">
                            <v-form ref="formGetInTouch" id="formGetInTouch" v-model="valid">
                                <v-text-field required v-model="name" :rules="nameRules" base-color="#C8C8F3"
                                    color="#C8C8F3B2" label="Name:" variant="underlined">
                                </v-text-field>

                                <v-text-field required v-model="email" :rules="emailRules" base-color="#C8C8F3"
                                    color="#C8C8F3B2" label="Email:" variant="underlined"></v-text-field>

                                <v-text-field required v-model="company" :rules="nameRules" base-color="#C8C8F3"
                                    color="#C8C8F3B2" label="Company:" variant="underlined"></v-text-field>

                                <v-radio-group required v-model="subject" :inline="$vuetify.display.mdAndUp"
                                    class="mt-5">
                                    <span class="radio-title mr-3 mt-1">Subject:</span>

                                    <v-radio value="radio-1" class="mx-1" color="#D91C49" base-color="#C8C8F3">
                                        <template v-slot:label>
                                            <div class="radio-label">General Inquiry</div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="radio-2" class="mx-1" color="#D91C49" base-color="#C8C8F3">
                                        <template v-slot:label>
                                            <div class="radio-label">Campaign Proposal</div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="radio-3" class="mx-1" color="#D91C49" base-color="#C8C8F3">
                                        <template v-slot:label>
                                            <div class="radio-label">Partnership</div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="radio-4" class="mx-1" color="#D91C49" base-color="#C8C8F3">
                                        <template v-slot:label>
                                            <div class="radio-label">Other</div>
                                        </template>
                                    </v-radio>
                                    <div class="line-bottom mt-2"></div>
                                </v-radio-group>

                                <v-textarea v-model="message" required rows="3" auto-grow base-color="#C8C8F3"
                                    color="#C8C8F3B2" label="Message" variant="underlined"></v-textarea>

                                <v-row justify="center" class="mt-10">
                                    <v-col cols="12" sm="10" md="8">
                                        <v-btn @click="SendMessage()" :disabled="!valid" color="#D91C49" variant="flat"
                                            class="form-btn" block size="large">
                                            Send message
                                        </v-btn>
                                        <p class="form-description text-center mt-4">By clicking “send message” you
                                            agree that your
                                            personal
                                            data will be processed by
                                            <i>WORK-O PRODUCTION OG</i>. We keep
                                            your information and personal data as confidential.
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-form>

                            <h5 class="social-media-title mt-8">Or find us in social media:</h5>

                            <v-row justify="center" class="mt-6">
                                <v-col cols="auto" class="pa-1 pa-sm-3">
                                    <v-btn icon size="x-large" variant="text" name="btn-contact-whatsapp"
                                        aria-label="btn-contact-whatsapp">
                                        <svg :width="$vuetify.display.xs ? '35px' : '48px'" viewBox="0 0 49 49"
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.2"
                                                d="M24.5003 6.125C21.2734 6.1246 18.1032 6.97403 15.3087 8.58786C12.5142 10.2017 10.194 12.523 8.58154 15.3182C6.96904 18.1134 6.12111 21.284 6.12305 24.511C6.12499 27.738 6.97672 30.9076 8.59257 33.7009L6.20574 40.8576C6.11576 41.1274 6.1027 41.4169 6.16803 41.6937C6.23335 41.9705 6.37448 42.2237 6.57558 42.4248C6.77669 42.6259 7.02983 42.767 7.30664 42.8323C7.58344 42.8976 7.87297 42.8846 8.14277 42.7946L15.2994 40.4078C17.7398 41.8186 20.4719 42.6491 23.2846 42.835C26.0972 43.0209 28.915 42.5572 31.5197 41.4798C34.1245 40.4024 36.4464 38.7402 38.306 36.6217C40.1655 34.5033 41.5127 31.9854 42.2433 29.263C42.974 26.5405 43.0685 23.6865 42.5196 20.9217C41.9707 18.1568 40.793 15.5554 39.0777 13.3185C37.3624 11.0817 35.1555 9.26949 32.6278 8.0221C30.1 6.77472 27.3191 6.12561 24.5003 6.125ZM29.0941 35.2188C25.033 35.2188 21.1382 33.6055 18.2665 30.7338C15.3949 27.8622 13.7816 23.9674 13.7816 19.9062C13.7816 18.2818 14.4269 16.7239 15.5756 15.5752C16.7242 14.4266 18.2821 13.7812 19.9066 13.7812L22.9691 19.9062L20.611 23.4415C21.5464 25.6767 23.3237 27.454 25.5588 28.3894L29.0941 26.0312L35.2191 29.0938C35.2191 30.7182 34.5738 32.2761 33.4251 33.4248C32.2765 34.5734 30.7185 35.2188 29.0941 35.2188Z"
                                                fill="#D91C49" />
                                            <path
                                                d="M35.9044 27.7233L29.7794 24.6608C29.5383 24.5406 29.2698 24.4862 29.0009 24.503C28.7321 24.5198 28.4724 24.6073 28.2482 24.7565L25.4364 26.6323C24.1457 25.9227 23.0835 24.8605 22.3739 23.5698L24.2497 20.758C24.3989 20.5337 24.4864 20.2741 24.5032 20.0052C24.52 19.7364 24.4655 19.4679 24.3454 19.2268L21.2829 13.1018C21.156 12.8454 20.9598 12.6297 20.7165 12.4792C20.4733 12.3287 20.1927 12.2493 19.9067 12.25C17.8761 12.25 15.9287 13.0566 14.4929 14.4925C13.0571 15.9283 12.2504 17.8757 12.2504 19.9062C12.2555 24.3719 14.0317 28.6533 17.1895 31.811C20.3472 34.9687 24.6285 36.7449 29.0942 36.75C30.0996 36.75 31.0952 36.552 32.0241 36.1672C32.953 35.7824 33.797 35.2185 34.508 34.5075C35.2189 33.7966 35.7829 32.9526 36.1676 32.0237C36.5524 31.0948 36.7504 30.0992 36.7504 29.0938C36.7506 28.8093 36.6716 28.5304 36.5222 28.2883C36.3727 28.0462 36.1588 27.8506 35.9044 27.7233ZM29.0942 33.6875C25.4404 33.6834 21.9375 32.2302 19.3539 29.6466C16.7702 27.063 15.317 23.56 15.3129 19.9062C15.3126 18.8442 15.6804 17.8148 16.3535 16.9933C17.0267 16.1718 17.9637 15.609 19.0052 15.4005L21.2025 19.8029L19.3325 22.5859C19.1927 22.7956 19.1069 23.0364 19.0825 23.2872C19.0581 23.5379 19.096 23.7908 19.1927 24.0234C20.2883 26.6273 22.3598 28.6987 24.9636 29.7943C25.197 29.8953 25.4518 29.9367 25.7051 29.9147C25.9583 29.8926 26.2022 29.8078 26.4145 29.668L29.2129 27.8037L33.6152 30.001C33.4051 31.044 32.8395 31.9816 32.015 32.654C31.1904 33.3263 30.1581 33.6916 29.0942 33.6875ZM24.5004 4.59375C21.0637 4.593 17.6853 5.48204 14.694 7.17434C11.7028 8.86665 9.20066 11.3046 7.43116 14.2508C5.66166 17.197 4.68507 20.5511 4.59646 23.9868C4.50785 27.4224 5.31024 30.8224 6.92552 33.8559L4.75306 40.3733C4.5731 40.9129 4.54699 41.492 4.67764 42.0456C4.80829 42.5992 5.09053 43.1055 5.49275 43.5077C5.89496 43.9099 6.40125 44.1922 6.95485 44.3228C7.50846 44.4534 8.08752 44.4273 8.62712 44.2474L15.1445 42.0749C17.8142 43.4949 20.7723 44.288 23.7942 44.394C26.8162 44.5 29.8225 43.9162 32.5852 42.6869C35.3478 41.4576 37.7941 39.615 39.7383 37.2991C41.6825 34.9832 43.0736 32.2548 43.8059 29.321C44.5382 26.3872 44.5926 23.3251 43.9648 20.3672C43.337 17.4093 42.0436 14.6333 40.1828 12.2498C38.322 9.86641 35.9426 7.93823 33.2253 6.61166C30.508 5.28509 27.5242 4.59499 24.5004 4.59375ZM24.5004 41.3438C21.5393 41.3458 18.6302 40.566 16.0671 39.0832C15.8794 38.9744 15.6708 38.9067 15.455 38.8846C15.2392 38.8625 15.0211 38.8865 14.8153 38.955L7.65669 41.3438L10.0435 34.1852C10.1123 33.9795 10.1366 33.7615 10.1149 33.5457C10.0931 33.3299 10.0257 33.1212 9.9172 32.9334C8.0605 29.7233 7.31505 25.9903 7.79647 22.3133C8.2779 18.6363 9.95929 15.221 12.5798 12.5972C15.2004 9.97335 18.6135 8.28764 22.2899 7.80157C25.9662 7.3155 29.7002 8.05624 32.9126 9.90888C36.125 11.7615 38.6362 14.6225 40.0567 18.048C41.4772 21.4735 41.7275 25.272 40.7689 28.8543C39.8102 32.4366 37.6962 35.6024 34.7547 37.8606C31.8133 40.1188 28.2088 41.3431 24.5004 41.3438Z"
                                                fill="#D91C49" />
                                        </svg>
                                    </v-btn>
                                </v-col>
                                <v-col cols="auto" class="pa-1 pa-sm-3">
                                    <v-btn icon size="x-large" variant="text" name="btn-contact-telegram"
                                        aria-label="btn-contact-telegram">
                                        <svg :width="$vuetify.display.xs ? '35px' : '48px'" viewBox="0 0 50 49"
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.2"
                                                d="M17.1879 38.2812V25.8149L25.8539 33.2626L19.8754 39.3416C19.6594 39.5613 19.3814 39.7127 19.0769 39.7764C18.7725 39.8402 18.4556 39.8134 18.1669 39.6994C17.8781 39.5855 17.6306 39.3896 17.4562 39.1369C17.2818 38.8843 17.1884 38.5863 17.1879 38.2812ZM45.0453 6.13838L5.46918 21.3188C5.22345 21.4115 5.01504 21.5798 4.87521 21.7984C4.73539 22.0171 4.6717 22.2742 4.69371 22.5314C4.71572 22.7885 4.82225 23.0317 4.99729 23.2244C5.17233 23.4172 5.40644 23.5491 5.66449 23.6004L17.1879 25.8149L45.3129 6.3585C45.3214 6.32393 45.3198 6.28775 45.3084 6.254C45.297 6.22025 45.2763 6.19027 45.2485 6.16742C45.2207 6.14457 45.187 6.12975 45.1511 6.12462C45.1153 6.11949 45.0786 6.12426 45.0453 6.13838Z"
                                                fill="#D91C49" />
                                            <path
                                                d="M46.2659 5.01294C46.0238 4.80808 45.7293 4.67183 45.414 4.61888C45.0988 4.56592 44.7747 4.59827 44.4768 4.71244L4.89481 19.8929C4.33384 20.1066 3.85892 20.4932 3.54154 20.9944C3.22416 21.4956 3.0815 22.0842 3.13504 22.6717C3.18857 23.2592 3.43541 23.8138 3.83839 24.2519C4.24137 24.6901 4.77868 24.9881 5.36942 25.101L15.6253 27.0744V38.2813C15.6233 38.8917 15.8084 39.4886 16.1566 39.9948C16.5049 40.5009 17.0002 40.8928 17.5784 41.1198C18.1557 41.3509 18.7906 41.4063 19.4006 41.279C20.0105 41.1517 20.5672 40.8474 20.9983 40.4059L25.9436 35.3795L33.7893 42.1094C34.3554 42.6014 35.0854 42.8737 35.8421 42.875C36.1736 42.8748 36.5031 42.8237 36.8186 42.7238C37.3342 42.5635 37.7978 42.2736 38.1635 41.8831C38.5291 41.4925 38.784 41.0149 38.9026 40.4977L46.8304 6.69923C46.9013 6.39442 46.8862 6.07644 46.7868 5.77937C46.6873 5.48231 46.5073 5.21737 46.2659 5.01294ZM34.3245 11.9036L16.8265 24.1842L7.137 22.3218L34.3245 11.9036ZM18.7503 38.2813V29.1933L23.5921 33.3545L18.7503 38.2813ZM35.846 39.8125L19.6975 25.9356L42.9397 9.61052L35.846 39.8125Z"
                                                fill="#D91C49" />
                                        </svg>
                                    </v-btn>
                                </v-col>
                                <v-col cols="auto" class="pa-1 pa-sm-3">
                                    <v-btn icon size="x-large" variant="text" name="btn-contact-instagram"
                                        aria-label="btn-contact-instagram">
                                        <svg :width="$vuetify.display.xs ? '35px' : '48px'" viewBox="0 0 49 49"
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.2"
                                                d="M33.6875 6.125H15.3125C12.8758 6.125 10.5389 7.09297 8.81596 8.81596C7.09297 10.5389 6.125 12.8758 6.125 15.3125V33.6875C6.125 36.1242 7.09297 38.4611 8.81596 40.184C10.5389 41.907 12.8758 42.875 15.3125 42.875H33.6875C36.1242 42.875 38.4611 41.907 40.184 40.184C41.907 38.4611 42.875 36.1242 42.875 33.6875V15.3125C42.875 12.8758 41.907 10.5389 40.184 8.81596C38.4611 7.09297 36.1242 6.125 33.6875 6.125ZM24.5 32.1562C22.9857 32.1562 21.5055 31.7072 20.2464 30.8659C18.9874 30.0247 18.006 28.8289 17.4265 27.4299C16.8471 26.0309 16.6954 24.4915 16.9909 23.0063C17.2863 21.5212 18.0155 20.157 19.0862 19.0862C20.157 18.0155 21.5212 17.2863 23.0063 16.9909C24.4915 16.6954 26.0309 16.8471 27.4299 17.4265C28.8289 18.006 30.0247 18.9874 30.8659 20.2464C31.7072 21.5055 32.1562 22.9857 32.1562 24.5C32.1562 26.5306 31.3496 28.478 29.9138 29.9138C28.478 31.3496 26.5306 32.1562 24.5 32.1562Z"
                                                fill="#D91C49" />
                                            <path
                                                d="M33.6875 4.59375H15.3125C12.4706 4.59679 9.74605 5.72706 7.73656 7.73656C5.72706 9.74605 4.59679 12.4706 4.59375 15.3125V33.6875C4.59679 36.5294 5.72706 39.2539 7.73656 41.2634C9.74605 43.2729 12.4706 44.4032 15.3125 44.4062H33.6875C36.5294 44.4032 39.2539 43.2729 41.2634 41.2634C43.2729 39.2539 44.4032 36.5294 44.4062 33.6875V15.3125C44.4032 12.4706 43.2729 9.74605 41.2634 7.73656C39.2539 5.72706 36.5294 4.59679 33.6875 4.59375ZM41.3438 33.6875C41.3438 35.7181 40.5371 37.6655 39.1013 39.1013C37.6655 40.5371 35.7181 41.3438 33.6875 41.3438H15.3125C13.2819 41.3438 11.3345 40.5371 9.89871 39.1013C8.46289 37.6655 7.65625 35.7181 7.65625 33.6875V15.3125C7.65625 13.2819 8.46289 11.3345 9.89871 9.89871C11.3345 8.46289 13.2819 7.65625 15.3125 7.65625H33.6875C35.7181 7.65625 37.6655 8.46289 39.1013 9.89871C40.5371 11.3345 41.3438 13.2819 41.3438 15.3125V33.6875ZM24.5 15.3125C22.6829 15.3125 20.9066 15.8513 19.3957 16.8609C17.8848 17.8704 16.7072 19.3053 16.0119 20.9841C15.3165 22.6629 15.1345 24.5102 15.489 26.2924C15.8435 28.0746 16.7186 29.7116 18.0035 30.9965C19.2884 32.2814 20.9254 33.1565 22.7076 33.511C24.4898 33.8655 26.3371 33.6835 28.0159 32.9881C29.6947 32.2928 31.1296 31.1152 32.1391 29.6043C33.1487 28.0934 33.6875 26.3171 33.6875 24.5C33.685 22.0641 32.7162 19.7287 30.9937 18.0063C29.2713 16.2838 26.9359 15.315 24.5 15.3125ZM24.5 30.625C23.2886 30.625 22.1044 30.2658 21.0971 29.5928C20.0899 28.9197 19.3048 27.9631 18.8412 26.8439C18.3777 25.7247 18.2564 24.4932 18.4927 23.3051C18.729 22.1169 19.3124 21.0256 20.169 20.169C21.0256 19.3124 22.1169 18.729 23.3051 18.4927C24.4932 18.2564 25.7247 18.3777 26.8439 18.8412C27.9631 19.3048 28.9197 20.0899 29.5928 21.0971C30.2658 22.1044 30.625 23.2886 30.625 24.5C30.625 26.1245 29.9797 27.6824 28.831 28.831C27.6824 29.9797 26.1245 30.625 24.5 30.625ZM36.75 14.5469C36.75 15.0012 36.6153 15.4452 36.3629 15.8229C36.1105 16.2007 35.7518 16.4951 35.3321 16.6689C34.9124 16.8428 34.4506 16.8882 34.005 16.7996C33.5595 16.711 33.1502 16.4922 32.829 16.171C32.5078 15.8498 32.289 15.4405 32.2004 14.995C32.1118 14.5494 32.1572 14.0876 32.3311 13.6679C32.5049 13.2482 32.7993 12.8895 33.177 12.6371C33.5548 12.3847 33.9988 12.25 34.4531 12.25C35.0623 12.25 35.6465 12.492 36.0773 12.9227C36.508 13.3535 36.75 13.9377 36.75 14.5469Z"
                                                fill="#D91C49" />
                                        </svg>
                                    </v-btn>
                                </v-col>
                                <v-col cols="auto" class="pa-1 pa-sm-3">
                                    <v-btn icon size="x-large" variant="text" name="btn-contact-facebook"
                                        aria-label="btn-contact-facebook">
                                        <svg :width="$vuetify.display.xs ? '35px' : '48px'" viewBox="0 0 49 49"
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.2"
                                                d="M42.875 24.5C42.875 28.1342 41.7973 31.6869 39.7783 34.7086C37.7592 37.7304 34.8894 40.0855 31.5318 41.4763C28.1742 42.867 24.4796 43.2309 20.9152 42.5219C17.3508 41.8129 14.0767 40.0629 11.5069 37.4931C8.93713 34.9233 7.18708 31.6492 6.47808 28.0848C5.76908 24.5204 6.13296 20.8258 7.52372 17.4682C8.91448 14.1106 11.2697 11.2408 14.2914 9.22175C17.3132 7.20267 20.8658 6.125 24.5 6.125C29.3734 6.125 34.0471 8.06093 37.4931 11.5069C40.9391 14.9529 42.875 19.6266 42.875 24.5Z"
                                                fill="#D91C49" />
                                            <path
                                                d="M24.5 4.59375C20.5629 4.59375 16.7143 5.76123 13.4407 7.94856C10.1671 10.1359 7.61569 13.2448 6.10903 16.8822C4.60238 20.5196 4.20816 24.5221 4.97625 28.3835C5.74434 32.245 7.64023 35.7919 10.4242 38.5758C13.2081 41.3598 16.7551 43.2557 20.6165 44.0238C24.4779 44.7918 28.4804 44.3976 32.1178 42.891C35.7552 41.3843 38.8641 38.8329 41.0514 35.5593C43.2388 32.2858 44.4063 28.4371 44.4063 24.5C44.4007 19.2222 42.3016 14.1622 38.5697 10.4303C34.8378 6.69837 29.7778 4.59932 24.5 4.59375ZM26.0313 41.2729V29.0938H30.625C31.0311 29.0938 31.4206 28.9324 31.7078 28.6453C31.9949 28.3581 32.1563 27.9686 32.1563 27.5625C32.1563 27.1564 31.9949 26.7669 31.7078 26.4797C31.4206 26.1926 31.0311 26.0312 30.625 26.0312H26.0313V21.4375C26.0313 20.6253 26.3539 19.8463 26.9282 19.272C27.5026 18.6977 28.2815 18.375 29.0938 18.375H32.1563C32.5624 18.375 32.9519 18.2137 33.239 17.9265C33.5262 17.6393 33.6875 17.2499 33.6875 16.8438C33.6875 16.4376 33.5262 16.0482 33.239 15.761C32.9519 15.4738 32.5624 15.3125 32.1563 15.3125H29.0938C27.4693 15.3125 25.9114 15.9578 24.7627 17.1065C23.6141 18.2551 22.9688 19.813 22.9688 21.4375V26.0312H18.375C17.9689 26.0312 17.5794 26.1926 17.2923 26.4797C17.0051 26.7669 16.8438 27.1564 16.8438 27.5625C16.8438 27.9686 17.0051 28.3581 17.2923 28.6453C17.5794 28.9324 17.9689 29.0938 18.375 29.0938H22.9688V41.2729C18.6522 40.8789 14.6536 38.8359 11.8049 35.5689C8.95612 32.302 7.47648 28.0626 7.6737 23.7325C7.87093 19.4024 9.72986 15.3151 12.8638 12.3206C15.9978 9.32619 20.1655 7.65518 24.5 7.65518C28.8346 7.65518 33.0023 9.32619 36.1362 12.3206C39.2702 15.3151 41.1291 19.4024 41.3263 23.7325C41.5235 28.0626 40.0439 32.302 37.1951 35.5689C34.3464 38.8359 30.3479 40.8789 26.0313 41.2729Z"
                                                fill="#D91C49" />
                                        </svg>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
    <v-overlay v-model="overlay" class="align-center justify-center">
        <v-progress-circular color="#d91c49" size="64" indeterminate></v-progress-circular>
    </v-overlay>
</template>
<script>
import axios from "axios";

export default {
    name: "GetInTouch",
    data: () => ({
        valid: false,
        overlay: false,
        name: "",
        email: "",
        company: "",
        subject: "",
        message: "",
        nameRules: [
            value => {
                if (value) return true

                return 'Input is required.'
            },
        ],
        emailRules: [
            (v) => !!v || "E-mail is required",
            (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
    }),
    methods: {
        SendMessage() {
            let subject = "";
            switch (this.subject) {
                case 'radio-1':
                    subject = "General Inquiry";
                    break;
                case 'radio-2':
                    subject = "Campaign Proposal";
                    break;
                case 'radio-3':
                    subject = "Partnership";
                    break;
                case 'radio-4':
                    subject = "Other";
                    break;
                default:
                    subject = "Other";
            }
            let vue = this;
            this.overlay = true;
            axios.post("/SendMessage.php", {
                name: this.name,
                email: this.email,
                company: this.company,
                subject: subject,
                message: this.message,
            })
                .then(() => {
                    this.$refs.formGetInTouch.reset();
                    setTimeout(() => {
                        vue.overlay = false
                    }, 1000);
                })
                .catch((err) => {
                    console.log(err);
                    setTimeout(() => {
                        vue.overlay = false;
                    }, 3000);
                });
        },
    }
}
</script>
<style>
#formGetInTouch .v-field__input {
    height: 68px;
}

#formGetInTouch .v-label.v-field-label {
    color: #C8C8F3B2;
    opacity: 1;
    font-size: 1.4rem;
}

#formGetInTouch .v-text-field textarea {
    padding-top: 30px;
}

#formGetInTouch .v-text-field input,
#formGetInTouch .v-text-field textarea {
    color: #C8C8F3;
    opacity: 1;
    font-size: 1.4rem;
}
</style>
<style scoped>
.social-media-title {
    color: #C8C8F3;
    font-size: 2rem;
    font-weight: 500;
    letter-spacing: -0.05em;
    text-align: center;

}

.form-btn.v-btn--disabled {
    background: #2B2B2A !important;
    opacity: 0.5;
}

.form-btn {
    border-radius: 20px;
    color: #C8C8F3;
    letter-spacing: -0.02em;
    font-weight: 500;
    font-size: 1.35rem;
    text-transform: inherit;
}

.form-description {
    color: #2B2B2A;
    font-size: 1rem;
    letter-spacing: -0.02em;
}

.radio-label {
    font-size: 1.4rem;
    background: linear-gradient(90deg, #9B6099 0%, #F7F8F8 77.07%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
}

.radio-title {
    color: #C8C8F3B2;
    font-size: 1.4rem;
}

.line-bottom {
    background: #c8c8f3;
    height: 1px;
    width: 100%;
    opacity: 0.38;
}

.card-main {
    background: linear-gradient(180deg, #000000 0%, #14081A 42%, #09040C 95%);
    border: 1px solid #FFFFFF1F;
    border-radius: 30px;
}

.text-subtitle {
    color: #997B8D;
    font-size: 1.05rem;
    letter-spacing: -0.02em;
}

.text-title {
    font-weight: 500;
    background: linear-gradient(90deg, #C1285F 0%, #F7F8F8 50%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    letter-spacing: -0.04em;
    font-size: 3.6rem;
}

.container-main {
    padding-top: 10vh;
    padding-bottom: 10vh;
}
</style>